import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { getTranslation } from './translations';
import LanguageSelector from './LanguageSelector';

function ForgotPassword() {
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsLoading(true);
    
    try {
      const response = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, language }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setMessage(getTranslation('password-reset-link-sent', language));
        setEmail('');
      } else {
        let errorMsg = getTranslation('password-reset-error-sending', language);
        if (data.detail) {
          if (Array.isArray(data.detail)) {
            errorMsg = data.detail.map(err => err.msg).join(' ');
          } else if (typeof data.detail === 'string') {
            errorMsg = data.detail;
          }
        }
        setMessage(errorMsg);
      }
    } catch (error) {
      setMessage(getTranslation('serverError', language));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f8ff',
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: window.innerWidth <= 600 ? '20px 20px' : '40px 0',
      fontFamily: 'Nunito, Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Language Selector */}
      <div style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 1000 }}>
        <LanguageSelector />
      </div>
      {/* Main Title */}
      <h1 style={{
        fontSize: window.innerWidth <= 600 ? '2.5rem' : '3.5rem',
        fontWeight: 'bold',
        color: '#7c3aed',
        margin: '0 0 16px 0',
        textAlign: 'center',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        ShootMe
      </h1>
      
      {/* Subtitle */}
      <p style={{
        fontSize: window.innerWidth <= 600 ? '1rem' : '1.2rem',
        color: '#6b7280',
        margin: '0 0 48px 0',
        textAlign: 'center',
        maxWidth: window.innerWidth <= 600 ? '90%' : '600px',
        lineHeight: '1.6',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        {getTranslation('password-reset', language)}
      </p>

      <div style={{
        background: 'white',
        borderRadius: window.innerWidth <= 600 ? 16 : 20,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
        maxWidth: window.innerWidth <= 600 ? '95%' : 400,
        width: window.innerWidth <= 600 ? '95%' : 400,
        padding: window.innerWidth <= 600 ? 24 : 32,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}>
        <h2 style={{ 
          color: '#7c3aed', 
          marginBottom: 24, 
          fontFamily: 'Nunito, Arial, sans-serif', 
          fontWeight: 700, 
          letterSpacing: 1,
          fontSize: window.innerWidth <= 600 ? '1.5rem' : '1.8rem',
          textAlign: 'center'
        }}>{getTranslation('forgot-password-title', language)}</h2>
        
        <p style={{
          color: '#6b7280',
          fontSize: window.innerWidth <= 600 ? '14px' : '16px',
          textAlign: 'center',
          marginBottom: 24,
          lineHeight: '1.5'
        }}>
          {getTranslation('forgot-password-description', language)}
        </p>
        
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={{ marginBottom: window.innerWidth <= 600 ? 16 : 18 }}>
            <label style={{ 
              color: '#4b4b4b', 
              fontWeight: 500,
              fontSize: window.innerWidth <= 600 ? '14px' : '16px'
            }}>{getTranslation('email', language)}:</label><br />
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              disabled={isLoading}
              style={{ 
                width: '100%', 
                padding: window.innerWidth <= 600 ? 12 : 10, 
                borderRadius: 8, 
                border: '1px solid #bdbdbd', 
                marginTop: 4, 
                fontSize: window.innerWidth <= 600 ? '16px' : '16px',
                boxSizing: 'border-box',
                opacity: isLoading ? 0.6 : 1
              }}
            />
          </div>
          <button 
            type="submit" 
            disabled={isLoading}
            style={{
              width: '100%',
              padding: window.innerWidth <= 600 ? '14px 0' : '12px 0',
              borderRadius: 8,
              border: 'none',
              background: isLoading ? '#9ca3af' : '#7c3aed',
              color: 'white',
              fontWeight: 700,
              fontSize: window.innerWidth <= 600 ? '16px' : '18px',
              letterSpacing: 1,
              boxShadow: isLoading ? 'none' : '0 4px 12px rgba(124, 58, 237, 0.3)',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              marginBottom: 8
            }}
          >
            {isLoading ? getTranslation('sending', language) : getTranslation('reset-password-button', language)}
          </button>
        </form>
        
        {message && <div style={{ 
          marginTop: 18, 
          color: message.includes('wysłany') ? '#2e7d32' : '#c62828', 
          fontWeight: 500,
          fontSize: window.innerWidth <= 600 ? '14px' : '16px',
          textAlign: 'center',
          padding: window.innerWidth <= 600 ? '0 10px' : '0'
        }}>{message}</div>}
        
        <div style={{ 
          textAlign: 'center', 
          marginTop: 24,
          fontSize: window.innerWidth <= 600 ? '14px' : '16px'
        }}>
          <button 
            type="button"
            onClick={() => navigate('/login')}
            style={{
              background: 'none',
              border: 'none',
              color: '#7c3aed',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: 'inherit',
              fontFamily: 'inherit'
            }}
          >
            {getTranslation('back-to-login', language)}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
